import {
	FolderZip as ArchiveIcon,
	InsertDriveFile as DefaultFileIcon,
	TableChart as ExcelIcon,
	Image as ImageIcon,
	PictureAsPdf as PdfIcon,
	Description as WordIcon,
} from '@mui/icons-material';
import { SxProps, Theme } from '@mui/material';
import React from 'react';

interface FileTypeIconProps {
	fileName: string;
	sx?: SxProps<Theme>;
}

const FileTypeIcon: React.FC<FileTypeIconProps> = ({ fileName, sx }) => {
	const getFileExtension = (name: string): string => {
		return name?.split('.').pop()?.toLowerCase() || '';
	};

	const fileExtension = getFileExtension(fileName);
	const defaultSx = { fontSize: '1.2rem', ...sx };

	switch (fileExtension) {
		case 'pdf':
			return <PdfIcon sx={{ ...defaultSx, color: '#f44336' }} />;
		case 'xlsx':
		case 'xls':
			return <ExcelIcon sx={{ ...defaultSx, color: '#4caf50' }} />;
		case 'docx':
		case 'doc':
			return <WordIcon sx={{ ...defaultSx, color: '#2196f3' }} />;
		case 'jpg':
		case 'jpeg':
		case 'png':
		case 'gif':
		case 'svg':
			return <ImageIcon sx={{ ...defaultSx, color: '#ff9800' }} />;
		case 'zip':
		case 'rar':
			return <ArchiveIcon sx={{ ...defaultSx, color: '#ffd700' }} />;
		default:
			return <DefaultFileIcon sx={defaultSx} />;
	}
};

export default FileTypeIcon;
